import DownArrow from "assets/Icons/downArrow.svg";
import HandMobile from "assets/Icons/handMobile.svg";
import UpArrow from "assets/Icons/upArrow.svg";

const HeroSectionContent = {
  main: {
    heading: "AI platform for seamless assistance with your",
    description:
      "Our patented technology gives the trust and comfort of rapid assistance and engagement tools anywhere, anytime.",
    button: "Start with Xane",
    animatedData: [
      {
        id: 1,
        icon: HandMobile,
        title: "45,00,000 +",
        subtitle: "Requests Supported",
      },
      {
        id: 2,
        icon: DownArrow,
        title: "80%",
        subtitle: "Cost of Service",
      },
      {
        id: 3,
        icon: UpArrow,
        title: "20%",
        subtitle: "User Retention",
      },
    ],
  },
};

export default HeroSectionContent;
